import woow from "../assets/img/projects/woow.png";
import yami from "../assets/img/projects/yami.png";
import pokecompany from "../assets/img/projects/pokecompany.png";
import message from "../assets/img/projects/message.png";
import mdlinks from "../assets/img/projects/mdlinks.png";
import calendar from "../assets/img/projects/calendar.png";
import heroes from "../assets/img/projects/heroes.png";
import ecommerce from "../assets/img/projects/ecommerce.png";
import journal from "../assets/img/projects/journal.png";
import indecision from "../assets/img/projects/indecision.png";
import speedometer from "../assets/img/projects/speedometer.png";
import footer from "../assets/img/projects/footer.png";
import pokemonguess from "../assets/img/projects/pokemonguess.png";
import emailInvoice from "../assets/img/projects/email-invoice.png";
import emailRecovery from "../assets/img/projects/email-recovery.png";
import emailRegistration from "../assets/img/projects/email-registration.png";
import emailSuscription from "../assets/img/projects/email-suscription.png";

export const projects = [
  {
    title: "Woow",
    descriptionKey: "project.woow.description",
    imgUrl: woow,
    technologies: [
      "React js",
      "Redux",
      "JavaScript",
      "Css3",
      "HTML5",
      "Firebase",
    ],
    categories: ["web", "design", "reactjs"],
    websites: [
      {
        type: "demo",
        url: "https://lim-016-burger-queen-dun.vercel.app",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/LIM016-burger-queen",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/joiZuUq1vL2G05FChzpxSF/Woow?type=design&node-id=38%3A3&mode=design&t=0ieHMx4Ywp72XHBZ-1",
      },
    ],
  },
  {
    title: "Yami",
    descriptionKey: "project.yami.description",
    imgUrl: yami,
    technologies: ["JavaScript", "Css3", "HTML5", "Firebase"],
    categories: ["web", "design"],
    websites: [
      {
        type: "demo",
        url: "https://mirianalejandra1996.github.io/YAMI-Social-Network/src",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/YAMI-LIM016-social-network",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/X1KzSlUwtP7WRYyYMpn0yD/Yami---Social-Media-App?type=design&node-id=56%3A7&mode=design&t=bU6y5RbmQnFxtOzd-1",
      },
    ],
  },
  {
    title: "PokéCompany",
    descriptionKey: "project.pokecompany.description",
    imgUrl: pokecompany,
    technologies: ["JavaScript", "Css3", "HTML5", "Chart js"],
    categories: ["web", "design"],
    websites: [
      {
        type: "demo",
        url: "https://mirianalejandra1996.github.io/LIM016-data-lovers/src/",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/LIM016-data-lovers",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/oS6kfL6x2GNsEec8Mwwkge/PokeCompany---Pokedex-App?type=design&node-id=0%3A1&mode=design&t=4kAxqKCj9zfu5x3D-1",
      },
    ],
  },
  {
    title: "Trust Message",
    descriptionKey: "project.trustmessage.description",
    imgUrl: message,
    technologies: ["JavaScript", "Css3", "HTML5"],
    categories: ["web", "design"],
    websites: [
      {
        type: "demo",
        url: "https://mirianalejandra1996.github.io/LIM016-cipher/src/",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/LIM016-cipher",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/xaUYhqLpDqpXpKFLihw8hV/Codigo-Cesar-App?type=design&node-id=0%3A1&mode=design&t=4kAxqKCj9zfu5x3D-1",
      },
    ],
  },
  {
    title: "Calendar App",
    descriptionKey: "project.calendar.description",
    imgUrl: calendar,
    technologies: [
      "React js",
      "Redux",
      "JavaScript",
      "Css3",
      "HTML5",
      "Node js",
      "MongoDB",
    ],
    categories: ["web", "design", "nodejs", "reactjs"],
    websites: [
      {
        type: "demo",
        url: "https://calendar-app-ale.vercel.app",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Calendar-App-Frontend",
      },
    ],
  },
  {
    title: "Heroes App",
    descriptionKey: "project.heroes.description",
    imgUrl: heroes,
    technologies: [
      "React js",
      "Redux",
      "JavaScript",
      "Css3",
      "HTML5",
      "Node js",
      "MongoDB",
    ],
    categories: ["web", "design", "fullstack", "reactjs"],
    websites: [
      {
        type: "demo",
        url: "https://heroes-app-alejandra-arevalo.netlify.app/marvel",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Heroes-App",
      },
    ],
  },
  {
    title: "E-commerce",
    descriptionKey: "project.ecommerce.description",
    imgUrl: ecommerce,
    technologies: [
      "React js",
      "Redux toolkit",
      "JavaScript",
      "Bootstrap",
      "Css3",
      "HTML5",
    ],
    categories: ["web", "design", "fullstack", "reactjs"],
    websites: [
      {
        type: "demo",
        url: "https://promart-app-project.web.app/promart",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/E-commerce-website/tree/main",
      },
    ],
  },
  {
    title: "Journal App",
    descriptionKey: "project.journal.description",
    imgUrl: journal,
    technologies: [
      "React js",
      "Redux",
      "JavaScript",
      "Bootstrap",
      "Css3",
      "HTML5",
    ],
    categories: ["web", "design", "fullstack", "reactjs"],
    websites: [
      {
        type: "demo",
        url: "https://my-journal-app-react-course.vercel.app/",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/journal-app-react-course",
      },
    ],
  },
  {
    title: "Indecision App",
    descriptionKey: "project.indecision.description",
    imgUrl: indecision,
    technologies: ["Vue", "JavaScript", "Css3", "HTML5"],
    categories: ["web", "vuejs"],
    websites: [
      {
        type: "demo",
        url: "https://indecision-vue-app.netlify.app",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Indecision-App-Vue",
      },
    ],
  },
  {
    title: "Speedometer",
    descriptionKey: "project.speedometer.description",
    imgUrl: speedometer,
    technologies: ["React js", "JavaScript", "Css3", "HTML5"],
    categories: ["web", "reactjs"],
    websites: [
      {
        type: "demo",
        url: "https://super-speedometer-app.netlify.app",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Super-Speedometer",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/DhjZLj5EUJPbUpt84bPRIz/Speedometer?type=design&node-id=0%3A1&mode=design&t=n7CmntMhypxIJs6v-1",
      },
    ],
  },
  {
    title: "Footer Responsive",
    descriptionKey: "project.footerresponsive.description",
    imgUrl: footer,
    technologies: ["React js", "JavaScript", "Css3", "HTML5"],
    categories: ["web", "reactjs"],
    websites: [
      {
        type: "demo",
        url: "https://mirianalejandra1996.github.io/footer-responsive",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/footer-responsive",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/WYOgPUyU4yCv1tVOxBE7u1/Footer-responsive?type=design&node-id=0%3A1&mode=design&t=BTxKFjNEenWhK1rD-1",
      },
    ],
  },
  {
    title: "MD-Links",
    descriptionKey: "project.mdlinks.description",
    imgUrl: mdlinks,
    technologies: ["Node js", "JavaScript", "Npm"],
    categories: ["web", "nodejs"],
    websites: [
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/LIM016-md-links",
      },
      {
        type: "package",
        url: "https://www.npmjs.com/package/@mialedev/md-links",
      },
    ],
  },
  {
    title: "Pokémon Game",
    descriptionKey: "project.pokemongame.description",
    imgUrl: pokemonguess,
    technologies: ["Vue", "JavaScript", "Css3", "HTML5"],
    categories: ["web", "vuejs"],
    websites: [
      {
        type: "demo",
        url: "https://pokemongame-miale-vue.netlify.app/",
      },
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/PokemonGame-Vue",
      },
    ],
  },
  {
    titleKey: "project.emailinvoice.title",
    title: "Factura de compra",
    descriptionKey: "project.emailinvoice.description",
    imgUrl: emailInvoice,
    technologies: ["Css3", "HTML5"],
    categories: ["email"],
    websites: [
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Email-Templates-Company",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/6mSO7fOBeGKYqYda82tTvZ/Email-templates?type=design&node-id=0%3A1&mode=design&t=stp795GO9qu86wF9-1",
      },
    ],
  },
  {
    titleKey: "project.emailregistration.title",
    title: "Creación de cuenta",
    descriptionKey: "project.emailregistration.description",
    imgUrl: emailRegistration,
    technologies: ["Css3", "HTML5"],
    categories: ["email"],
    websites: [
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Email-Templates-Company",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/6mSO7fOBeGKYqYda82tTvZ/Email-templates?type=design&node-id=0%3A1&mode=design&t=stp795GO9qu86wF9-1",
      },
    ],
  },
  {
    titleKey: "project.emailsuscription.title",
    title: "Suscripción de servicio",
    descriptionKey: "project.emailsuscription.description",
    imgUrl: emailSuscription,
    technologies: ["Css3", "HTML5"],
    categories: ["email"],
    websites: [
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Email-Templates-Company",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/6mSO7fOBeGKYqYda82tTvZ/Email-templates?type=design&node-id=0%3A1&mode=design&t=stp795GO9qu86wF9-1",
      },
    ],
  },
  {
    titleKey: "project.emailrecovery.title",
    title: "Recuperación de cuenta",
    descriptionKey: "project.emailrecovery.description",
    imgUrl: emailRecovery,
    technologies: ["Css3", "HTML5"],
    categories: ["email"],
    websites: [
      {
        type: "code",
        url: "https://github.com/mirianalejandra1996/Email-Templates-Company",
      },
      {
        type: "figma",
        url: "https://www.figma.com/file/6mSO7fOBeGKYqYda82tTvZ/Email-templates?type=design&node-id=0%3A1&mode=design&t=stp795GO9qu86wF9-1",
      },
    ],
  },
];
